import React from 'react';
import PropTypes from 'prop-types';
import {Space} from 'antd';
import {StyledAgentAlert, StyledAgentAlertIconWrapper} from './StyledAgentAlert';
import {StarsIcon} from '../../icons';
import {colorsStyles} from '../../utils/styles';

const ExpenseDetailsTabAlert = ({message, ...rest}) => (
  <StyledAgentAlert {...rest}>
    <Space size='small' align='start'>
      <StyledAgentAlertIconWrapper size={16} color={colorsStyles.additional_purple} colorMode='stroke'>
        <StarsIcon />
      </StyledAgentAlertIconWrapper>
      <span>{message}</span>
    </Space>
  </StyledAgentAlert>
);

ExpenseDetailsTabAlert.propTypes = {
  message: PropTypes.node.isRequired,
};

export default ExpenseDetailsTabAlert;
